import { NgModule } from '@angular/core';
import { APOLLO_NAMED_OPTIONS, NamedOptions } from 'apollo-angular';
import { InMemoryCache, ApolloLink } from '@apollo/client/core';
import { HttpHeaders } from '@angular/common/http';
import { HttpLink } from 'apollo-angular/http';
import { setContext } from '@apollo/client/link/context';
import { environment } from 'src/environments/environment';

export function createApollo(httpLink: HttpLink) {
    const basic = setContext((_operation, context) => {
        const headers =
            context.headers instanceof HttpHeaders
                ? context.headers
                : new HttpHeaders(context.headers ?? {});

        return {
            headers: headers.set('Accept', 'charset=utf-8'),
        };
    });

    const auth = setContext((_operation, context) => {
        const token = localStorage.getItem('token');

        if (token === null) {
            return {};
        } else {
            const headers =
                context.headers instanceof HttpHeaders
                    ? context.headers
                    : new HttpHeaders(context.headers ?? {});

            return {
                headers: headers.set('Authorization', `JWT ${token}`),
            };
        }
    });

    const link = ApolloLink.from([
        basic,
        auth,
        httpLink.create({ uri: environment.cms.api }),
    ]);
    const cache = new InMemoryCache();

    return {
        link,
        cache,
    };
}

@NgModule({
    exports: [],
    providers: [
        {
            provide: APOLLO_NAMED_OPTIONS,
            useFactory(httpLink: HttpLink): NamedOptions {
                return {
                    cms: {
                        cache: new InMemoryCache(),
                        link: httpLink.create({ uri: environment.cms.api }),
                    },
                    icons: {
                        cache: new InMemoryCache(),
                        link: httpLink.create({ uri: environment.iconServer }),
                    },
                };
            },
            deps: [HttpLink],
        },
    ],
})
export class GraphQLModule {}
